import { Content, BookMark } from '../../types'

interface ContentState {
  jwVideo: object
  currentVideos: Array<Content>
  currentQuizzes: Array<Content>
  currentExercises: Array<Content>
  currentLabs: Array<Content>
  currentIFrames: Array<Content>
  currentBookmarks: Array<BookMark>
  currentHoveredNote: string
  playingVideoId: string
  playingVideoTime: number
  isWatchingFullscreen: boolean
  currentQuizId: string
  currentExerciseId: string
  isContentLoading: boolean
  coursesForBookmarks: Array<object>
  videosForBookmarks: Array<Content>
}

const state: ContentState = {
  jwVideo: {},
  currentVideos: [],
  currentQuizzes: [],
  currentExercises: [],
  currentLabs: [],
  currentIFrames: [],
  currentBookmarks: [],
  currentHoveredNote: '',
  playingVideoId: '',
  playingVideoTime: 0,
  isWatchingFullscreen: false,
  currentQuizId: '',
  currentExerciseId: '',
  isContentLoading: false,
  coursesForBookmarks: [],
  videosForBookmarks: [],
}

export { ContentState, state }
